import { makeStyles } from '@lifeomic/chroma-react/styles';

/**
 * @description Styles shared across all variant types.  Typically used
 * in the table view of the OE, or in the variant details modal.
 */
export const useSharedStyles = makeStyles(() => ({
  innerIconButton: {
    '& > svg': {
      width: 14,
      height: 14,
    },
  },
}));
